import React, { useEffect, useState, useCallback } from "react";
import axios from "axios";
import { FiSave, FiUpload, FiTrash2 } from "react-icons/fi";
import { useDropzone } from "react-dropzone";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import PageHeaderSetting from "../shared/pageHeader/PageHeaderSetting";
import PerfectScrollbar from "react-perfect-scrollbar";
import useTranslations from "../../hooks/useTranslations";
import useUserLanguage from "../../hooks/useUserLanguage";
import Footer from "../shared/Footer";
import { useSearchParams } from "react-router-dom";


const BASE_URL = process.env.REACT_APP_API_BASE_URL;
const FILE_BASE_URL = `${process.env.REACT_APP_API_BASE_URL}`;

const SettingGeneralForm = () => {
  const language = useUserLanguage();
  const { translations } = useTranslations(language);
  const getText = (key, defaultValue) => translations[key] || defaultValue;
  // Metinsel alanlar
  const [titleSuffix, setTitleSuffix] = useState("");
  const [copyright, setCopyright] = useState("");
  const [footerText, setFooterText] = useState("");
  const [copyrightText, setCopyrightText] = useState("");

  // Logo dosyaları
  const [logoHeader, setLogoHeader] = useState(null);
  const [logoFooter, setLogoFooter] = useState(null);
  const [favicon, setFavicon] = useState(null);
  const searchParams = new URLSearchParams(window.location.search);
  const lang = searchParams.get("lang") || "tr";
  // Sayfa yüklendiğinde verileri çek
  useEffect(() => {
    fetchGeneralSettings();
  }, [lang]);

  // 1) Verileri getirme
  const fetchGeneralSettings = async () => {
    try {
      const resp = await axios.get(
        `${BASE_URL}/api/general?lang=${lang}`
      );
      console.log("Gelen Data:", resp.data);

      // Metinsel alanlar
      setTitleSuffix(resp.data.title_suffix || "");
      setCopyright(resp.data.copyright || "");
      setCopyrightText(resp.data.copyright_text || "");
      setFooterText(resp.data.footer_text || "");

      // Logo path -> DB’de "/uploads/headerLogo/..."
      if (resp.data.logo_header) {
        setLogoHeader({ preview: FILE_BASE_URL + resp.data.logo_header });
      } else {
        setLogoHeader(null);
      }

      if (resp.data.logo_footer) {
        setLogoFooter({ preview: FILE_BASE_URL + resp.data.logo_footer });
      } else {
        setLogoFooter(null);
      }

      if (resp.data.favicon) {
        setFavicon({ preview: FILE_BASE_URL + resp.data.favicon });
      } else {
        setFavicon(null);
      }
    } catch (err) {
      console.error("Veri çekme hatası:", err);
      toast.error("Genel ayarlar alınamadı!");
    }
  };

  // 2) LOGO HEADER Dropzone
  const onLogoHeaderDrop = useCallback((acceptedFiles) => {
    if (acceptedFiles.length > 0) {
      const file = acceptedFiles[0];
      setLogoHeader(
        Object.assign(file, { preview: URL.createObjectURL(file) }),
      );
    }
  }, []);
  const removeLogoHeader = () => setLogoHeader(null);
  const {
    getRootProps: getLogoHeaderRootProps,
    getInputProps: getLogoHeaderInputProps,
    isDragActive: isLogoHeaderDragActive,
  } = useDropzone({
    onDrop: onLogoHeaderDrop,
    accept: "image/*",
    maxFiles: 1,
  });

  // 3) LOGO FOOTER Dropzone
  const onLogoFooterDrop = useCallback((acceptedFiles) => {
    if (acceptedFiles.length > 0) {
      const file = acceptedFiles[0];
      setLogoFooter(
        Object.assign(file, { preview: URL.createObjectURL(file) }),
      );
    }
  }, []);
  const removeLogoFooter = () => setLogoFooter(null);
  const {
    getRootProps: getLogoFooterRootProps,
    getInputProps: getLogoFooterInputProps,
    isDragActive: isLogoFooterDragActive,
  } = useDropzone({
    onDrop: onLogoFooterDrop,
    accept: "image/*",
    maxFiles: 1,
  });

  // 4) FAVICON Dropzone
  const onFaviconDrop = useCallback((acceptedFiles) => {
    if (acceptedFiles.length > 0) {
      const file = acceptedFiles[0];
      setFavicon(Object.assign(file, { preview: URL.createObjectURL(file) }));
    }
  }, []);
  const removeFavicon = () => setFavicon(null);
  const {
    getRootProps: getFaviconRootProps,
    getInputProps: getFaviconInputProps,
    isDragActive: isFaviconDragActive,
  } = useDropzone({
    onDrop: onFaviconDrop,
    accept: "image/*",
    maxFiles: 1,
  });

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      // 1) Metinsel alanları güncelle
      await axios.put(`${BASE_URL}/api/general/update`, {
        lang: lang,
        titleSuffix,
        copyright,
        copyright_text: copyrightText,
        footerText,
      });

// HeaderLogo için:
if (logoHeader && logoHeader instanceof File) {
  const fd = new FormData();
  fd.append("logo", logoHeader);
  await axios.post(
    `${BASE_URL}/api/general/headerLogo/uploadLogo?lang=${lang}`, 
    fd
  );
}

// FooterLogo için:
if (logoFooter && logoFooter instanceof File) {
  const fd = new FormData();
  fd.append("logo", logoFooter);
  await axios.post(
    `${BASE_URL}/api/general/footerLogo/uploadLogo?lang=${lang}`, 
    fd
  );
}

// Favicon için:
if (favicon && favicon instanceof File) {
  const fd = new FormData();
  fd.append("logo", favicon);
  await axios.post(
    `${BASE_URL}/api/general/favicon/uploadLogo?lang=${lang}`, 
    fd
  );
}

      // 5) Başarılı işlem sonrası
      toast.success("Ayarlar başarıyla güncellendi!");
      // Tekrar GET yapıp güncel verileri çekelim
      fetchGeneralSettings();
    } catch (err) {
      console.error("Güncelleme hatası:", err);
      toast.error("Ayarlar güncellenirken hata oluştu!");
    }
  };

  // ------------------------------------------------------

  return (
    <div className="content-area setting-form">
      <ToastContainer />
      <PerfectScrollbar>
        <PageHeaderSetting />
        <div className="content-area-body">
          <div className="card mb-0">
            <div className="card-body">
              {/* Title Suffix */}
              <div className="mb-3">
                <label className="form-label fw-bold">
                  {getText("MENU_SETTINGS_TITLE_SUFFIX")}
                </label>
                <input
                  type="text"
                  className="form-control"
                  value={titleSuffix}
                  onChange={(e) => setTitleSuffix(e.target.value)}
                />
              </div>

              {/* Copyright */}
              <div className="mb-3">
                <label className="form-label fw-bold">
                  {getText("MENU_SETTINGS_COPYRIGHT")}
                </label>
                <input
                  type="text"
                  placeholder="Copyright"
                  className="form-control"
                  value={copyright}
                  onChange={(e) => setCopyright(e.target.value)}
                />
              </div>
              <div className="mb-3">
                <label className="form-label fw-bold">
                  {getText("MENU_SETTINGS_COPYRIGHT_TEXT")}
                </label>
                <input
                  type="text"
                  placeholder={getText(
                    "MENU_SETTINGS_COPYRIGHT_TEXT_PLACEHOLDER",
                  )}
                  className="form-control"
                  value={copyrightText}
                  onChange={(e) => setCopyrightText(e.target.value)}
                />
              </div>

              {/* Footer Text */}
              <div className="mb-3">
                <label className="form-label fw-bold">
                  {getText("MENU_SETTINGS_FOOTER_TEXT")}
                </label>
                <textarea
                  className="form-control"
                  rows="3"
                  value={footerText}
                  onChange={(e) => setFooterText(e.target.value)}
                />
              </div>

              {/* Logo Header */}
              <div className="mb-3">
                <label className="form-label fw-bold">
                  {getText("MENU_SETTINGS_LOGO_HEADER")}
                </label>
                <DropzoneBox
                  getRootProps={getLogoHeaderRootProps}
                  getInputProps={getLogoHeaderInputProps}
                  isDragActive={isLogoHeaderDragActive}
                  file={logoHeader}
                  removeFile={removeLogoHeader}
                  placeholderText={getText(
                    "UPLOAD_LOGO_HEADER",
                    "Upload Header Logo",
                  )}
                  previewStyle={{
                    width: "280px",
                    height: "80px",
                    objectFit: "contain",

                    borderRadius: "8px",
                  }}
                />
              </div>

              {/* Logo Footer */}
              <div className="mb-3">
                <label className="form-label fw-bold">
                  {getText("MENU_SETTINGS_LOGO_FOOTER")}
                </label>
                <DropzoneBox
                  getRootProps={getLogoFooterRootProps}
                  getInputProps={getLogoFooterInputProps}
                  isDragActive={isLogoFooterDragActive}
                  file={logoFooter}
                  removeFile={removeLogoFooter}
                  placeholderText={getText(
                    "UPLOAD_LOGO_FOOTER",
                    "Upload Footer Logo",
                  )}
                  previewStyle={{
                    width: "280px",
                    height: "80px",
                    objectFit: "contain",

                    borderRadius: "8px",
                  }}
                />
              </div>

              {/* Favicon */}
              <div className="mb-3">
                <label className="form-label fw-bold">
                  {getText("MENU_SETTINGS_FAVICON")}
                </label>
                <DropzoneBox
                  getRootProps={getFaviconRootProps}
                  getInputProps={getFaviconInputProps}
                  isDragActive={isFaviconDragActive}
                  file={favicon}
                  removeFile={removeFavicon}
                  placeholderText={getText("UPLOAD_FAVICON")}
                  previewStyle={{
                    width: "100px",
                    height: "80px",
                    objectFit: "contain",

                    borderRadius: "8px",
                  }}
                />
              </div>

              {/* Kaydet Butonu */}
              <div className="d-flex justify-content-center mt-4">
                <button
                  type="button"
                  className="btn btn-primary"
                  onClick={handleSubmit}
                >
                  <FiSave className="me-2" /> {getText("SAVE_BTN")}
                </button>
              </div>
            </div>
          </div>
        </div>
      </PerfectScrollbar>
    </div>
  );
};

// -----------------------------------------
// DropzoneBox Bileşeni
// -----------------------------------------
const DropzoneBox = ({
  getRootProps,
  getInputProps,
  isDragActive,
  file,
  removeFile,
  placeholderText,
  previewStyle,
}) => {
  const baseStyle = {
    border: "2px dashed #007bff",
    padding: "20px",
    borderRadius: "8px",
    textAlign: "center",
    cursor: "pointer",
    transition: "0.2s ease-in-out",
  };

  // "Aktif" => yeşil kenarlık
  const activeStyle = isDragActive
    ? { borderColor: "#28a745", backgroundColor: "#e6ffed" }
    : {};
  const language = useUserLanguage();
  const { translations } = useTranslations(language);
  const getText = (key, defaultValue) => translations[key] || defaultValue;

  let combinedStyle = { ...baseStyle, ...activeStyle };

  let previewSrc = "";
  const BASE_URL = `${process.env.REACT_APP_API_BASE_URL}`;

  if (file) {
    if (file instanceof File) {
      previewSrc = file.preview;
    } else if (file.preview) {
      // Eğer path “/uploads/...” ile başlıyorsa direkt BASE_URL + preview
      if (file.preview.startsWith("/cdn")) {
        previewSrc = file.preview;
      } else {
        // (gerekirse başka formatları da destekle)
        previewSrc = file.preview;
      }
    }
  }

  return (
    <div {...getRootProps()} style={combinedStyle}>
      <input {...getInputProps()} />
      {!file ? (
        <div className="d-flex flex-column align-items-center">
          <FiUpload size={32} className="text-primary" />
          <p className="mt-2 mb-0">{placeholderText}</p>
        </div>
      ) : (
        <div className="uploaded-file d-flex flex-column align-items-center">
          {previewSrc && (
            <img
              src={previewSrc}
              alt="Preview"
              style={previewStyle || { width: 100, height: 100 }}
            />
          )}
          <button
            type="button"
            className="btn btn-sm btn-outline-danger mt-2"
            onClick={(e) => {
              e.stopPropagation();
              removeFile();
            }}
          >
            <FiTrash2 className="me-1" />
            {getText("DELETE")}
          </button>
        </div>
      )}
    </div>
  );
};

export default SettingGeneralForm;
